import { render, staticRenderFns } from "./svg-icon.vue?vue&type=template&id=3b294a4e&scoped=true"
import script from "./svg-icon.vue?vue&type=script&lang=ts"
export * from "./svg-icon.vue?vue&type=script&lang=ts"
import style0 from "./svg-icon.vue?vue&type=style&index=0&id=3b294a4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b294a4e",
  null
  
)

export default component.exports